import * as MuiCollapse from '@mui/material/Collapse'

export type CollapseProps = MuiCollapse.CollapseProps

export function Collapse({ children, ...props }: CollapseProps) {
  return <MuiCollapse.default {...props}>{children}</MuiCollapse.default>
}
